import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar.jsx";
import Banner from "../Section/Banner/banner";
import About from "../Section/About/about.jsx";
import Flash from "../Section/Flash/Flash.jsx";
import Soon from "../Section/Soon/Csoon.jsx";
import Cresta from "../Section/Cresta/Cresta.jsx";
import PromoNavara from "../Section/Promo Navara/promonavara.jsx";
import Navara from "../Section/Navara/Navara.jsx";
import Promo from "../Section/Newlaunch/Newlaunch.jsx";
import ProdukAbout from "../Section/ProdukAbout/Aboutproduk.jsx";
import Produk from "../Section/Produk/Produk.jsx";
import Siaphuni from "../Section/Siaphuni/Siaphuni.jsx";
import Surrounding from "../Section/Surrounding/Surrounding.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footerup/footerup.jsx";
import Scrolltohashelement from "../Pages/ScrollToHashElement";
import tombol from "../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283899578378&text=Halo%20Tari,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Harapan%20Indah%20https://kotaharapanindahmarketing.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <About />
      <Flash />
      <Soon />
      <Cresta />
      <PromoNavara />
      <Navara />
      <Siaphuni />
      <Promo />
      <ProdukAbout />
      <Produk />
      <Surrounding />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
